module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('emapm-upload-imgs', {
    ref: "upload",
    staticClass: "emapm-uploa-imgs",
    attrs: {
      "host": _vm.host,
      "label": _vm.model.caption,
      "host-pathname": _vm.hostPathname,
      "read-only": _vm.param.readonly || _vm.param.disabled,
      "required": _vm.param.required,
      "token": _vm.value,
      "size": 4000,
      "max-number": _vm.maxNumber,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign,
      "file-name": _vm.fileName
    },
    on: {
      "on-token-change": _vm.onTokenChange
    }
  })
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-form/emapComponents/emUploadImage.vue